import TrackerFormPage from "@/features/pages/components/TrackerFormPage";
import { resolveTrackerDueEntry } from "@/features/diaries/utils/findEarliestDueEntry";
import { formatTrackerLateralityBanner } from "@/features/pages/utils/trackerLateralityBanner";
import { useAppLocale } from "@/features/i18n/LocaleProvider";
import useExtractTracker from "@/features/trackers/hooks/useExtractTracker";
import type { PageViewT } from "@patient-watch/types";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

const searchSchema = z.object({
    is_unscheduled: z.boolean().optional(),
    /** Editing one page of a finished entry: save returns to `returnTo`. */
    edit: z.boolean().optional(),
    returnTo: z.string().optional(),
});

const Page = () => {
    const { diaryId, pageIndex, trackerId } = Route.useParams();
    const { is_unscheduled } = Route.useSearch();
    const { locale } = useAppLocale();
    const tracker = useExtractTracker(diaryId, trackerId);
    if (!tracker) {
        return <p>Tracker not found</p>;
    }

    if (!tracker.form) {
        return <p>Form not available</p>;
    }

    const page = tracker.form.pages.find((p: PageViewT) => p.page_index === Number(pageIndex));

    if (!page) {
        return <p>Page not found</p>;
    }

    const lateralityBanner = formatTrackerLateralityBanner(tracker.side, locale);

    return (
        <div className="flex flex-col flex-1">
            <TrackerFormPage
                pageIndex={Number(pageIndex)}
                form={tracker.form}
                route={Route}
                nextEntry={is_unscheduled ? null : resolveTrackerDueEntry(tracker)}
                diaryId={diaryId}
                lateralityBanner={lateralityBanner}
            />
        </div>
    );
};

export const Route = createFileRoute("/_app/diaries/$diaryId/new/tracker/$trackerId/entry/$entryId/page/$pageIndex/")({
    validateSearch: searchSchema,
    component: Page,
});
